import React from "react";

import BASELoading from "../../../../../../../@BASE/core/BASELoading";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

import ReadingAttribution from "../components/ReadingAttribution";
import EMentor from "../components/EMentor";
import Instructions from "../components/Instructions";
import ComponentCard from "../components/Component";
import ComponentPreview from "../components/Preview";
import ComponentStepLabel from "../components/StepLabel";
import SubComponentCard from "../components/SubComponent";

export default function PEReading(props) {
  const { data, dir, ins = [], course, comments = [] } = props;
  const tl = `${dir === "rtl" ? "text-18" : "text-14"} ${course?.language?.acronym}`.trim();

  if (!data) {
    return <BASELoading />;
  }

  // filer comments by component_id
  const componentCommentsCount = (component) => {
    return comments.filter(
      (comment) =>
        comment.component === component && comment.internality !== true
    ).length;
  };

  return (
    <div>
      <style>
        {`
            .wysiwyg p {
                margin: 0px;
                margin-bottom: 1.5rem;
            }
        `}
      </style>

      <Instructions
        ins={ins}
        course={course}
        dir={dir}
        tl={tl}
        componentCommentsCount={componentCommentsCount}
      />

      <ComponentCard
        title="Content"
        id="content"
        commentsCount={componentCommentsCount("content")}
      >
        <ComponentStepLabel number="1" title="Reading:" />
        <ReadingAttribution
          attribution={data.core}
          tl={tl}
          dir={dir}
          componentCommentsCount={componentCommentsCount}
        />
        {data.focus_points.length !== 0 && (
          <>
            <ComponentStepLabel number="2" title="Focus Points:" />
            {data.focus_points.map((data, index) => (
              <SubComponentCard
                key={data.id}
                title={"Focus Point " + (index + 1)}
                id={data.id}
                commentsCount={componentCommentsCount(data.id)}
              >
                <Paper elevation={0} square className="p-16">
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Typography className={`${tl} font-bold m-0`} dir={dir}>
                        {data.focus_header}
                      </Typography>
                      <Divider className="my-16" />
                    </Grid>
                    <Grid item xs={12}>
                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={4} lg={2}>
                          <Typography className="text-14 font-semibold m-0">
                            Linked To:
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={8} lg={10}>
                          <Typography className={`${tl} m-0`} dir={dir}>
                            {data.linked_item}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={4} lg={2}>
                          <Typography className="text-14 font-semibold m-0">
                            Content:
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={8} lg={10}>
                          <Typography
                            className={`${tl} wysiwyg m-0`}
                            dir={dir}
                            dangerouslySetInnerHTML={{
                              __html: data.focus_content,
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Paper>
              </SubComponentCard>
            ))}
          </>
        )}
      </ComponentCard>

      {data.eMentor.length !== 0 && (
        <EMentor
          eMentor={data.eMentor}
          tl={tl}
          dir={dir}
          componentCommentsCount={componentCommentsCount}
        />
      )}
    </div>
  );
}
